const AGE_ENTRY_KEY = 'fm-age-entry-v1';

export type AgeEntryStatus = 'accepted' | null;

export function getAgeEntryStatus(): AgeEntryStatus {
  try {
    const value = localStorage.getItem(AGE_ENTRY_KEY);
    return value === 'accepted' ? 'accepted' : null;
  } catch {
    return null;
  }
}

export function setAgeEntryAccepted(): void {
  try {
    localStorage.setItem(AGE_ENTRY_KEY, 'accepted');
  } catch {
    // Storage unavailable — gate will reappear next visit.
  }
}

export function clearAgeEntryStatus(): void {
  try {
    localStorage.removeItem(AGE_ENTRY_KEY);
  } catch {
    // ignore
  }
}
